import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Label} from '@/components/ui/label'
import {Textarea} from '@/components/ui/textarea'
import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from '@/components/ui/dialog'
import {DateField} from '@/components/date-field'
import {FieldError} from '@/components/field-error'
import {FormDialogFooter} from '@/components/form-dialog-footer'
import {validateRequired} from '@/lib/validation'
import {tope} from '@/lib/campos-texto'

/** El plazo es obligatorio: sin uno la fila dice «plazo sin definir» y nunca pasa a rojo. */
export function PedirSoporteDialog({
  abierto,
  titulo,
  notaPorDefecto,
  onCerrar,
  onConfirmar,
  guardando,
  error,
  testId,
}: {
  abierto: boolean
  titulo: string
  notaPorDefecto: string
  onCerrar: () => void
  onConfirmar: (plazo: string, nota: string) => void
  guardando: boolean
  error?: string | null
  testId: string
}) {
  const {t} = useTranslation()
  const [plazo, setPlazo] = useState('')
  const [nota, setNota] = useState('')
  const [hallazgo, setHallazgo] = useState<string | undefined>()
  if (!abierto) return null
  return (
    <Dialog open onOpenChange={onCerrar}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{titulo}</DialogTitle>
          <DialogDescription>{t('cumplimiento.pedir.descripcion')}</DialogDescription>
        </DialogHeader>
        <form
          noValidate
          className="space-y-3"
          onSubmit={(evento) => {
            evento.preventDefault()
            const problema = validateRequired(plazo)
            setHallazgo(problema ?? undefined)
            if (!problema) onConfirmar(plazo, nota || notaPorDefecto)
          }}>
          <DateField
            id={`${testId}-plazo`}
            label={t('cumplimiento.pedir.plazo')}
            value={plazo}
            onChange={(valor) => {
              setPlazo(valor)
              setHallazgo(validateRequired(valor) ?? undefined)
            }}
          />
          <FieldError error={hallazgo} />
          <div className="space-y-1.5">
            <Label htmlFor={`${testId}-nota`}>{t('cumplimiento.pedir.nota')}</Label>
            <Textarea
              maxLength={tope('NOTA')}
              id={`${testId}-nota`}
              value={nota}
              onChange={(evento) => setNota(evento.target.value)}
              data-testid={`${testId}-nota`}
            />
          </div>
          <FormDialogFooter
            onCancel={onCerrar}
            submitLabel={t('cumplimiento.pedir.confirmar')}
            pending={guardando}
            error={error ?? null}
          />
        </form>
      </DialogContent>
    </Dialog>
  )
}
